import { useIntersectionObserver, useWindowSize } from "@uidotdev/usehooks";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import account from "../../assets/imgs/homepage/contact.png";
import esclip1 from "../../assets/imgs/homepage/Ellipse 154.png";
import esclip from "../../assets/imgs/homepage/Ellipse 155.png";
import notifi from "../../assets/imgs/homepage/notifi.png";
import record from "../../assets/imgs/homepage/record.png";
import girl from "../../assets/imgs/homepage/Rectangle-Copy.png";
import soundbox from "../../assets/imgs/homepage/soundbox2.svg.png";
import cafe from "../../assets/svgs/cafe.svg";
import check from "../../assets/svgs/check.svg";
import frequent from "../../assets/svgs/frenquent.svg";
import online from "../../assets/svgs/online.svg";
import payment from "../../assets/svgs/payment.svg";
import poor from "../../assets/svgs/poor.svg";
import retail from "../../assets/svgs/retails.svg";
import sound from "../../assets/svgs/soundbox.svg";
import { AccordionComponent } from "../../components/accordions";
import { ButtonNumber, LeafButton } from "../../components/buttons";
import { Contact } from "../../components/contact/Contact";
import { SliderMulipItems } from "../../components/slicksdiler";
import { HaveALookItem, SoundBoxWorkItem } from "../../components/soundboxwork";
import { UpiSoundboxItem } from "../../components/upisoundbox/UpiSoundboxItem";
export const SoundBox = () => {
  const { width } = useWindowSize();
  const { t, i18n } = useTranslation();

  const [currentTitle, setCurrentTitle] = useState(t("homepage.enhanced"));
  const [currentHeader, setCurrentHeader] = useState(t("homepage.enhanceddes"));
  const handleButtonClick1 = () => {
    setCurrentTitle(t("homepage.enhanced"));
    setCurrentHeader(t("homepage.enhanceddes"));
  };

  const handleButtonClick2 = () => {
    setCurrentTitle(t("homepage.quality"));
    setCurrentHeader(t("homepage.qualitydes"));
  };
  const handleButtonClick3 = () => {
    setCurrentTitle(t("homepage.better"));
    setCurrentHeader(t("homepage.betterdes"));
  };
  const handleButtonClick4 = () => {
    setCurrentTitle(t("homepage.ongoing"));
    setCurrentHeader(t("homepage.ongoingdes"));
  };
  const handleButtonClick5 = () => {
    setCurrentTitle(t("homepage.secured"));
    setCurrentHeader(t("homepage.secureddes"));
  };
  useEffect(() => {
    if (activeButton == 1) {
      setCurrentTitle(t("homepage.enhanced"));
      setCurrentHeader(t("homepage.enhanceddes"));
    } else if (activeButton == 2) {
      setCurrentTitle(t("homepage.quality"));
      setCurrentHeader(t("homepage.qualitydes"));
    } else if (activeButton == 3) {
      setCurrentTitle(t("homepage.better"));
      setCurrentHeader(t("homepage.betterdes"));
    } else if (activeButton == 4) {
      setCurrentTitle(t("homepage.ongoing"));
      setCurrentHeader(t("homepage.ongoingdes"));
    } else {
      setCurrentTitle(t("homepage.secured"));
      setCurrentHeader(t("homepage.secureddes"));
    }
  }, [t]);

  const [activeButton, setActiveButton] = useState(1); // State để theo dõi nút hiện đang được kích hoạt

  const handleButtonClick = (buttonNumber) => {
    setActiveButton(buttonNumber); // Cập nhật state để chỉ định nút được kích hoạt
  };
  const [ref, entry] = useIntersectionObserver({
    threshold: 0,
    root: null,
    rootMargin: "0px",
  });
  const [ref1, entry1] = useIntersectionObserver({
    threshold: 0,
    root: null,
    rootMargin: "0px",
  });
  const [ref2, entry2] = useIntersectionObserver({
    threshold: 0,
    root: null,
    rootMargin: "0px",
  });

  const [isVisible, setIsVisible] = useState(false);
  const [isVisible1, setIsVisible1] = useState(false);
  const [isVisible2, setIsVisible2] = useState(false);
  useEffect(() => {
    if (entry && entry.isIntersecting && !isVisible) {
      setIsVisible(true); // Đánh dấu đã gặp isIntersecting
    }
  }, [entry, isVisible]);
  useEffect(() => {
    if (entry1 && entry1.isIntersecting && !isVisible1) {
      setIsVisible1(true); // Đánh dấu đã gặp isIntersecting
    }
  }, [entry1, isVisible1]);
  useEffect(() => {
    if (entry2 && entry2.isIntersecting && !isVisible2) {
      setIsVisible2(true); // Đánh dấu đã gặp isIntersecting
    }
  }, [entry2, isVisible2]);

  return (
    <div className="relative mt-[145px]">
      <Helmet>
        <title>Soundbox | Trusted Pay</title>
      </Helmet>
      <img className="absolute left-0 top-[0]" src={esclip} alt="" />
      <img className="absolute right-0 top-[0]" src={esclip1} alt="" />
      <div className="absolute left-[50%] top-[50px] h-[24px] w-[24px] animate-movesquare rounded-[24px] bg-[#FF9B26]"></div>
      <div className="absolute left-[40%] top-[450px] h-[42px] w-[39px] animate-movesquare-slow rounded-[24px] bg-[#565ADD]"></div>

      {/* SOUNDBOX */}
      <div className="relative mx-auto max-w-[1280px] px-4 mothaibaysaimin:px-8">
        {width > 1024 ? (
          <div className="flex items-center gap-[30px] sm:flex-col">
            <div className="max-w-[625px] ">
              <p className="animate-fadeInDown text-[40px] font-bold text-[--color-text] whitespace-pre-wrap">
                {t("homepage.title")}
              </p>
              <div className="animate-fadeInUp">
                <p className="text-4 mt-[20px] max-w-[625px] font-semibold text-[--color-text] ">
                  {t("homepage.des")}
                </p>
                <LeafButton
                  title={t("homepage.get")}
                  style={{ marginTop: "36px" }}
                />
              </div>
            </div>
            <div className="relative">
              <img
                className="h-[500px] w-[606px] lg:w-[500px] lgmax:h-[400px]"
                src={soundbox}
                alt=""
              />
              <div className="absolute top-0 left-1/3 -z-10">
                <div className="absolute left-0 top-[-20px] h-[500px] w-[500px] animate-spin rounded-[50%] border border-solid border-blue-200">
                  <div className="absolute left-[200px] top-[-5px] h-[14px] w-[14px] rounded-[50%] bg-[#FF9B26]"></div>
                </div>
                <div className="absolute left-[40px] top-[16px] h-[420px] w-[420px] rounded-[50%] border border-solid border-blue-200"></div>
                <div className="absolute left-[80px] top-[52px] h-[340px] w-[340px] animate-spin rounded-[50%] border border-solid border-blue-200">
                  <div className="absolute left-[200px] top-[-5px] h-[14px] w-[14px] rounded-[50%] bg-[#565ADD]"></div>
                </div>
                <div className="absolute left-[120px] top-[82px] h-[260px] w-[260px] rounded-[50%] border border-solid border-blue-200"></div>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex animate-fadeInDown items-center gap-[30px] sm:flex-col">
            <div className="relative">
              <img
                className="h-[500px] w-[606px] lg:w-[500px] lgmax:h-[400px]"
                src={soundbox}
                alt=""
              />
              <div className="absolute top-0 -z-10">
                <div className="absolute left-0 top-[-20px] h-[500px] w-[500px] animate-spin rounded-[50%] border border-solid border-blue-200">
                  <div className="absolute left-[200px] top-[-5px] h-[14px] w-[14px] rounded-[50%] bg-[#FF9B26]"></div>
                </div>
                <div className="absolute left-[40px] top-[16px] h-[420px] w-[420px] rounded-[50%] border border-solid border-blue-200"></div>
                <div className="absolute left-[80px] top-[52px] h-[340px] w-[340px] animate-spin rounded-[50%] border border-solid border-blue-200">
                  <div className="absolute left-[200px] top-[-5px] h-[14px] w-[14px] rounded-[50%] bg-[#565ADD]"></div>
                </div>
                <div className="absolute left-[120px] top-[82px] h-[260px] w-[260px] rounded-[50%] border border-solid border-blue-200"></div>
              </div>
            </div>
            <div className="max-w-[625px]">
              <p className="text-[40px] font-bold text-[--color-text] ">
                {t("homepage.title")}
              </p>
              <p className="text-4 mt-[20px] max-w-[625px] font-semibold text-[--color-text]">
                {t("homepage.des")}
              </p>
              <LeafButton
                title={t("homepage.get")}
                style={{ marginTop: "36px" }}
              />
            </div>
          </div>
        )}
      </div>
      <div ref={ref}>
        <div
          className={`relative mx-auto max-w-[1280px] px-[80px] py-[50px] sm:px-4  ${isVisible ? "animate-fadeInUp" : null}`}
        >
          <div className="flex flex-col items-center justify-center gap-[20px]">
            <div className="group">
              <img
                src={sound}
                className="w-[200px] animate-spin  transition-all group-hover:animate-hover"
                alt=""
              />
            </div>

            <h1 className="max-w-[1240px]  text-center text-[36px] font-bold text-[--color-title]">
              {t("homepage.getan")}{" "}
              <span className="text-[--color-hover]">
                {t("homepage.soundboxne")}
              </span>{" "}
              {t("homepage.sound")}
            </h1>
            <p className="text-4 max-w-[780px] text-center font-montserrat text-[--color-text]">
              {t("homepage.trust")}
            </p>
          </div>
        </div>
      </div>

      <div ref={ref1}>
        <div
          className={`rounded-tr-[200px] bg-[#EFF0FF] sm:rounded-tl-[50px] sm:rounded-tr-[50px] ${isVisible1 ? "animate-fadeInUp" : null}`}
        >
          <div className="mx-auto flex max-w-[1280px] flex-col gap-[20px] px-[50px] py-[50px] sm:px-4">
            <h1 className="max-w-[1240px] text-center text-[36px] font-bold text-[--color-title]">
              {i18n.language === "vi" ? (
                <>
                  <span className="text-[--color-hover]">
                    {t("homepage.soundboxwork")}{" "}
                  </span>
                  {t("homepage.howdoese")}{" "}
                </>
              ) : (
                <>
                  {t("homepage.howdoese")}{" "}
                  <span className="text-[--color-hover]">
                    {t("homepage.soundboxwork")}{" "}
                  </span>
                </>
              )}
            </h1>
            <div className="flex lgmax:flex-wrap lgmax:justify-center">
              <SoundBoxWorkItem
                image={account}
                titleheader={t("homepage.connaction")}
                title={t("homepage.connactdes")}
              />
              <SoundBoxWorkItem
                image={account}
                titleheader={t("homepage.account")}
                title={t("homepage.accountdes")}
              />
              <SoundBoxWorkItem
                image={notifi}
                titleheader={t("homepage.notifi")}
                title={t("homepage.notifides")}
              />
              <SoundBoxWorkItem
                image={record}
                titleheader={t("homepage.record")}
                title={t("homepage.recorddes")}
              />
            </div>
          </div>
        </div>
      </div>

      <div ref={ref2}>
        <div
          className={`relative min-h-[570px]  bg-soundbox bg-cover bg-center bg-no-repeat sm:h-full   ${isVisible2 ? "animate-fadeInUp" : null}`}
        >
          <div
            className="absolute bottom-0 left-0 right-0 top-0 min-h-[570px] bg-soundboxOverlay opacity-[0.63]
                sm:h-full "
          ></div>
          <div className="left-26 absolute z-[100] h-0 w-48 border-dashed  border-white bg-white"></div>
          <div
            className={`relative  mx-auto  max-w-[1280px] px-4 pb-[12px] pt-[70px]`}
          >
            <div>
              <h1 className="max-w-[1240px]  text-center text-[36px] font-bold text-[#fff]">
                {t("homepage.whatare")}{" "}
                <span className="text-[--color-hover]">
                  {t("homepage.upisoundbox")}
                </span>{" "}
              </h1>
              <div>
                <div className="absolute left-[17%] top-[39%] w-[65%] border-[1px] border-dashed border-white sm:hidden"></div>
                <div className="absolute left-[17%] top-[39.5%] w-[65%] border-[1px] border-dashed border-white sm:hidden"></div>
                <div className="relative flex sm:flex-col sm:items-center sm:justify-center sm460:gap-[30px] ">
                  <UpiSoundboxItem
                    image={payment}
                    titleheader={t("homepage.payment")}
                    title={t("homepage.paymentdes")}
                    height={"lgmin:min-h-[300px]"}
                  />
                  <UpiSoundboxItem
                    image={frequent}
                    titleheader={t("homepage.frequent")}
                    title={t("homepage.frequentdes")}
                    height={"lgmin:min-h-[300px]"}
                  />
                  <UpiSoundboxItem
                    image={poor}
                    titleheader={t("homepage.poor")}
                    title={t("homepage.poordes")}
                    height={"lgmin:min-h-[300px]"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="h-[520px] bg-[#EFF0FF] sm:h-[570px] lg:h-[580px]">
        <div className="mx-auto max-w-[1400px] flex-col gap-[20px] px-[50px]  py-[50px] sm:px-[16px]">
          <h1 className="ml-[30px] max-w-[1240px] text-center text-[36px] font-bold text-[--color-title] sm:ml-0">
            {t("homepage.bene")}{" "}
            <span className="text-[--color-hover]">
              {t("homepage.soundboxne")}{" "}
            </span>
          </h1>
          <SliderMulipItems />
        </div>
      </div>

      <div className="relative bg-white">
        <div
          className={`mx-auto  flex max-w-[1280px] items-center justify-center px-4 py-[50px] pt-[50px] sm:flex-wrap lg:flex-wrap`}
        >
          <div className="relative max-w-[640px]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="sm:w-[375px]"
              width="544"
              height="544"
              viewBox="0 0 544 544"
              fill="none"
            >
              <path
                opacity="0.03"
                d="M271.751 0.350098C421.618 0.350098 543.109 121.841 543.109 271.707C543.109 421.573 421.618 543.065 271.751 543.065C121.885 543.065 0.394043 421.574 0.394043 271.707C0.394043 121.841 121.885 0.350098 271.751 0.350098Z"
                fill="#2B1C50"
              />
            </svg>
            <div className=" absolute left-[60px] top-[60px] h-[420px]  w-[420px] rounded-[50%] border border-dashed  border-[#565ADD] sm:left-[46px] sm:top-[124px] sm:h-[300px] sm:w-[279px]"></div>
            <img
              className="absolute left-0 top-0 ml-[95px] mt-[26px] sm:ml-[85px] sm:mt-[90px] sm:w-[268px] mothaibaysaimin:w-[383px]"
              src={girl}
              alt=""
            />
          </div>
          <div className="ml-[60px] sm:ml-0 lgmax:ml-0">
            <h1 className="text-[36px] font-bold text-[--color-title]">
              {i18n.language === "vi" ? (
                <>
                  {t("homepage.have")}
                  <span className="text-[--color-hover]">
                    {t("homepage.upisoundbox2")}
                  </span>
                </>
              ) : (
                <>
                  {t("homepage.have")}
                  <span className="text-[--color-hover]">
                    {t("homepage.soundboxne")}
                  </span>
                </>
              )}
            </h1>
            {}

            <HaveALookItem
              image={cafe}
              titleheader={t("homepage.public")}
              title={t("homepage.publicdes")}
              bottomValue={"bottom-[64px]"}
              paddingleft={"pl-[10px]"}
            />

            <HaveALookItem
              image={cafe}
              titleheader={t("homepage.cafes")}
              title={t("homepage.cafedes")}
              bottomValue={"bottom-[40px]"}
              paddingleft={"pl-[10px]"}
            />

            <HaveALookItem
              image={retail}
              titleheader={t("homepage.retail")}
              title={t("homepage.retaildes")}
              bottomValue={"bottom-[40px]"}
              paddingleft={"pl-[10px]"}
            />

            <HaveALookItem
              image={online}
              titleheader={t("homepage.online")}
              title={t("homepage.onlinedes")}
              bottomValue={
                i18n.language === "en" ? "bottom-[40px]" : "bottom-[64px]"
              }
              paddingleft={"pl-[10px]"}
            />
          </div>
        </div>
      </div>

      <div className="bg-white sm:py-[50px]">
        <div className="mx-auto flex max-w-[1280px] justify-between px-4 py-[50px] pt-[50px] sm:py-0 lgmaxmin:flex-col lgmaxmin:items-center">
          <div className={`mr-[10px] flex flex-1 flex-col gap-[20px]`}>
            <h1 className="max-w-[520px] text-[36px] font-bold  text-[--color-title] lgmaxmin:max-w-[850px]">
              {t("homepage.whychoose")}
              <span className="text-[--color-hover]">
                {t("homepage.soundboxne")}
              </span>
              {t("homepage.servie")}
            </h1>
            <p className="text-4 max-w-[620px] font-montserrat text-[#3D2E7C] lgmaxmin:max-w-[850px]">
              {t("homepage.whychoosedes")}
            </p>
            <div className="group flex items-start gap-[30px] p-4 sm:flex-col sm:items-center">
              <img
                className="group-hover:animate-hover sm:h-[43px] sm:w-[43px]"
                src={check}
                alt=""
              />
              <div className="sm:text-center">
                <p className="border-b-solid inline-block border-b-4 border-b-[#f1f1f1] pb-[12px] text-[24px] font-bold text-[#333]">
                  {currentTitle}
                </p>

                <p className="text-4 mt-[10px]  font-normal text-[#3D2E7C] lg:max-w-[650px]">
                  {currentHeader}
                </p>
              </div>
            </div>
            <div className="flex gap-[30px] sm:gap-[5px]">
              <ButtonNumber
                title={"1"}
                onClick={() => {
                  handleButtonClick1();
                  handleButtonClick(1);
                }} // Gọi hai hàm xử lý sự kiện
                isActive={activeButton === 1}
              />
              <ButtonNumber
                title={"2"}
                onClick={() => {
                  handleButtonClick2();
                  handleButtonClick(2);
                }} // Gọi hai hàm xử lý sự kiện
                isActive={activeButton === 2}
              />
              <ButtonNumber
                title={"3"}
                onClick={() => {
                  handleButtonClick3();
                  handleButtonClick(3);
                }} // Gọi hai hàm xử lý sự kiện
                isActive={activeButton === 3}
              />
              <ButtonNumber
                title={"4"}
                onClick={() => {
                  handleButtonClick4();
                  handleButtonClick(4);
                }} // Gọi hai hàm xử lý sự kiện
                isActive={activeButton === 4}
              />
              <ButtonNumber
                title={"5"}
                onClick={() => {
                  handleButtonClick5();
                  handleButtonClick(5);
                }} // Gọi hai hàm xử lý sự kiện
                isActive={activeButton === 5}
              />
            </div>
          </div>
          <div className="flex flex-1 flex-col gap-[20px]  lg:mt-[20px] lgmax:mt-[20px]">
            <h1 className="max-w-[520px] text-[36px] font-bold text-[--color-title]">
              FA<span className="text-[--color-hover]">Q's</span>
            </h1>
            <AccordionComponent
              header1={t("homepage.which")}
              des1={t("homepage.whichdes")}
              header2={t("homepage.howto")}
              des2={t("homepage.howtodes")}
              header3={t("homepage.isthere")}
              des3={t("homepage.istheredes")}
              header4={t("homepage.dowe")}
              des4={t("homepage.dowedes")}
              header5={t("homepage.howcan")}
              des5={t("homepage.howcandes")}
            />
          </div>
        </div>
      </div>

      <Contact
        header={t("homepage.connact")}
        headertitle={t("homepage.withus")}
        headerdes={t("homepage.withusdes")}
      />
    </div>
  );
};
